import { GET_KLAGE_KODER_URL } from "../constants/api";
import * as axios from "../utils/axiosUtils";

export const actionType = "KLAGE_KODER";

export const getKlageKoder = () => {
  return axios.GetAll(GET_KLAGE_KODER_URL, actionType);
};
